import React from 'react';
import { Grid, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { FiUserCheck, FiMonitor, FiLock, FiDownloadCloud } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { MODULOS } from '../../api/config';

interface ButtonConfig {
  icon: any;
  color: string;
  label: string;
  link: string;
  internal?: boolean;
}

const ModuleButtons: React.FC = () => {
  const navigate = useNavigate();

  // Os enderecos vinham escritos aqui, em http://. Agora saem de api/config, em https e num
  // lugar so. "Controle de Acesso" aponta para a tela de links: la cada porta ja vem com a sala
  // certa, em vez de abrir o modulo sem sala e o operador escolher numa lista.
  // "Pré-Inscrição" saiu: inscricao.quantictechnology.com.br nao resolve, entao o botao abria
  // uma aba quebrada. Volta quando existir o modulo dedicado de pre-inscricao, para eventos
  // gratuitos que nao passam pelo Venda de Ingressos.
  const buttons: ButtonConfig[] = [
    { icon: FiUserCheck, color: 'green.500', label: 'Credenciamento', link: MODULOS.credenciamento },
    { icon: FiMonitor, color: 'orange.500', label: 'Auto Atendimento', link: MODULOS.autoatendimento },
    { icon: FiLock, color: 'red.500', label: 'Controle de Acesso', link: '/admin/terminais', internal: true },
    { icon: FiDownloadCloud, color: 'teal.500', label: 'Importar UGART', link: '/admin/ugart-import', internal: true },
  ];

  const handleButtonClick = (btn: ButtonConfig) => {
    if (btn.internal) {
      navigate(btn.link);
    } else {
      window.open(btn.link, '_blank');
    }
  };

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' }} gap={6}>
      {buttons.map((btn, index) => (
        <Button
          key={index}
          size="lg"
          height={{ base: '100px', md: '140px' }}
          bg={btn.color}
          color="white"
          rounded="2xl"
          shadow="2xl"
          _hover={{ bg: `${btn.color}`, transform: 'scale(1.05)', shadow: '2xl' }}
          transition="all 0.2s"
          onClick={() => handleButtonClick(btn)}
        >
          <Flex direction="column" align="center">
            <Icon as={btn.icon} boxSize={{ base: 10, md: 12 }} mb={2} />
            <Text fontSize={{ base: 'sm', md: 'lg' }}>{btn.label}</Text>
          </Flex>
        </Button>
      ))}
    </Grid>
  );
};

export default ModuleButtons;
